"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignedQuoteReply = exports.SignedQuoteDetails = exports.SignedQuoteFee = exports.HaulerSignedQuoteRequest = exports.SignedQuoteRequest = exports.QuotePartialAddressWithZip = exports.QuotePartialAddress = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const roll_off_pricing_snapshot_1 = require("./roll-off-pricing-snapshot");
exports.QuotePartialAddress = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(common_1.AddressTransport, ['state']),
    typebox_1.Type.Partial(typebox_1.Type.Omit(common_1.AddressTransport, ['state'])),
]);
exports.QuotePartialAddressWithZip = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(common_1.AddressTransport, ['zip']),
    typebox_1.Type.Partial(typebox_1.Type.Omit(common_1.AddressTransport, ['zip'])),
]);
exports.SignedQuoteRequest = typebox_1.Type.Object({
    location: typebox_1.Type.Object({
        address: exports.QuotePartialAddress,
        lat: typebox_1.Type.Number(),
        lng: typebox_1.Type.Number(),
    }),
    material: common_1.Material,
    size: typebox_1.Type.Number(),
    rentalPeriod: common_1.Duration,
    weightLimit: typebox_1.Type.Number(),
    priorQuote: typebox_1.Type.Optional(typebox_1.Type.String()),
    /** When set, must match the zone from /pricing/by-service-location (Order Roll Off uses data[0]). */
    pricingZoneID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    supposedlyTaxExempt: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    supposedlyNotCard: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
exports.HaulerSignedQuoteRequest = typebox_1.Type.Object({
    location: typebox_1.Type.Object({
        address: exports.QuotePartialAddressWithZip,
        lat: typebox_1.Type.Number(),
        lng: typebox_1.Type.Number(),
    }),
    material: common_1.Material,
    size: typebox_1.Type.Number(),
    pricingTierID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    // rentalPeriod: DurationTransport,
    // weightLimit: Type.Number(),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
});
exports.SignedQuoteFee = typebox_1.Type.Object({
    name: typebox_1.Type.String(),
    type: typebox_1.Type.Union([typebox_1.Type.Literal('payment_fee'), typebox_1.Type.Literal('regular_fee')]),
    amount: typebox_1.Type.Number(),
    taxable: typebox_1.Type.Boolean(),
});
exports.SignedQuoteDetails = typebox_1.Type.Object({
    location: typebox_1.Type.Object({
        address: exports.QuotePartialAddress,
        lat: typebox_1.Type.Number(),
        lng: typebox_1.Type.Number(),
    }),
    haul: typebox_1.Type.Number(),
    dump: typebox_1.Type.Number(),
    tax: typebox_1.Type.Number(),
    taxRate: typebox_1.Type.Number(),
    cc: typebox_1.Type.Number(),
    actualRentExtension: typebox_1.Type.Number(),
    prepaidRentalDaysDiscount: typebox_1.Type.Number(),
    total: typebox_1.Type.Number(),
    overage: typebox_1.Type.Number(),
    totalWithoutTax: typebox_1.Type.Number(),
    rentExtensionFee: typebox_1.Type.Number(),
    material: common_1.Material,
    size: typebox_1.Type.Number(),
    tonLimit: typebox_1.Type.Number(),
    rentalPeriod: common_1.Duration,
    priceType: typebox_1.Type.String(),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    subtotalWithoutTaxesAndFees: typebox_1.Type.Number(),
    supposedlyTaxExempt: typebox_1.Type.Boolean(),
    supposedlyNotCard: typebox_1.Type.Boolean(),
    pricingZoneID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    pricingTierID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    // Per-item taxability flags mirror V4.calculatePricing's `taxHaul`/`taxDump` logic at quote-signing time.
    // Order-item rows downstream should use these instead of hardcoded defaults so the persisted
    // taxable flag matches the tax actually billed in `tax`.
    taxableHaul: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    taxableDump: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    sourgumPricingSnapshot: typebox_1.Type.Optional(roll_off_pricing_snapshot_1.RollOffPricingSnapshot),
    fees: typebox_1.Type.Optional(typebox_1.Type.Array(exports.SignedQuoteFee)),
    idempotencyKey: typebox_1.Type.String(),
});
exports.SignedQuoteReply = typebox_1.Type.Object({
    quoteDetails: exports.SignedQuoteDetails,
    token: typebox_1.Type.String(),
});
//# sourceMappingURL=signed-quotes.js.map